jQuery(document).ready(function($) {
    $(".toggle_menu").click(function (e) {
        $(".div_menu").toggle();
        e.preventDefault();
    });
    // Click on concept-illustration-points
    $('.concept-focus').click(function(f){
        $('.concept-box').removeClass('active');
        $('.concept-focus').removeClass('active');
        $('.concept-box[id='+($(this).attr('target'))+']').addClass('active');
        $(this).addClass('active');
        f.stopPropagation();
    });
    // Click on the info-boxes
    $('.concept-box').click(function(g){
        $('.concept-box').removeClass('active');
        $('.concept-focus').removeClass('active');
        $('.concept-focus[target='+(this.id)+']').addClass('active');
        $(this).addClass('active');
        g.stopPropagation();
    });
    $(document).click(function(){
        $('.concept-box').removeClass('active');
        $('.concept-focus').removeClass('active');
    });

    /**
     * Copyright 2012, Digital Fusion
     * Licensed under the MIT license.
     * http://teamdf.com/$-plugins/license/
     *
     * @author Sam Sehnert
     * @desc A small plugin that checks whether elements are within
     *     the user visible viewport of a web browser.
     *     only accounts for vertical position, not horizontal.
     */

    $.fn.visible = function (partial) {

        var $t = $(this),
            $w = $(window),
            viewTop = $w.scrollTop(),
            viewBottom = viewTop + $w.height(),
            _top = $t.offset().top,
            _bottom = _top + $t.height(),
            compareTop = partial === true ? _bottom : _top,
            compareBottom = partial === true ? _top : _bottom;

        return ((compareBottom <= viewBottom) && (compareTop >= viewTop));

    };

    var win = $(window);

    var allMods = $(".animate-item");

    allMods.each(function (i, el) {
        var el = $(el);
        if (el.visible(true)) {
            el.addClass("already-visible");
        }
    });

    win.scroll(function (event) {

        allMods.each(function (i, el) {
            var el = $(el);
            if (el.visible(true)) {
                el.addClass("come-in");
            }
        });

    });

    //
    // Trigger support-dropdown on mobile
    //
    $('.subheading-support + h1 ').click(function(){
        $('nav.support').toggleClass('active');
    });

    //
    // Trigger OWL
    //
    $(".owl-carousel").owlCarousel({
        items: 1,
        nav: true,
        navText: ['<span class="prev"></span>','<span class="next"></span>'],
        loop: true
    });

});
